import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { getCountries } from "shared/gol-api/exportCountries";
import { dayMonthYearFormat } from "shared/lib/datetime";

import Img from "@components/FileServer/Img";
import Table from "@components/UI/Table";

import { FormContext } from "./Forms/HooksForm";
import PassportDocumentsForm from "./Forms/PassportDocumentsForm";

export function PassportDocuments({
  formVals,
  setFormVals,
  defaultCountry,
  errors,
  setErrors,
}) {
  const intl = useIntl();
  const { setSubmitPressed } = useContext(FormContext);
  const [showForm, setShowForm] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [index, setIndex] = useState(null);
  const [countries, setCountries] = useState([]);

  const passports = formVals?.passports;

  const isEmpty =
    formVals?.passports?.length === 0 ||
    (formVals?.passports[0].Number.trim() === "" && !formVals?.passports[1]);

  useEffect(() => {
    const blockSection = (attribute) => {
      const element = document.getElementById("passport");
      if (element) {
        element.style.pointerEvents = attribute;
      }
    };

    if (showForm) {
      blockSection("none");
    }

    return () => {
      blockSection("auto");
      setErrors({
        ...errors,
        Number: false,
        ValidityDate: false,
        Issued: false,
        Citizenship: false,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showForm]);

  useEffect(() => {
    async function loadData() {
      const resp = await getCountries({ includeStates: false });
      if (resp.success) setCountries(resp.data.Country);
    }
    loadData();
  }, []);

  const deletePassport = (passport) => {
    const newPassports = formVals.passports.filter(
      (currentPassport) => currentPassport.Number !== passport.Number
    );

    setFormVals({ ...formVals, passports: newPassports });
  };

  const createNewPassport = async () => {
    setIsNew(true);
    setSubmitPressed(false);
    setFormVals({
      ...formVals,
      passports: [
        ...formVals.passports,
        {
          Number: "",
          ValidityDate: "",
          Issued: "",
          Citizenship: "",
        },
      ],
    });

    setIndex(formVals.passports.length);
    setShowForm(true);
  };

  const countryDetailRow = (countryCode) =>
    countries.find((c) => c.Code === countryCode)?.$t;

  const menuItems = (_, idx) => (
    <>
      <div
        role="button"
        className="profile-table__menu-item"
        id={`edit-passport-${idx}`}
        onClick={async () => {
          await setIndex(idx);
          return await setShowForm(true);
        }}
      >
        <FormattedMessage id="Profile.editIdentityDocument" />
      </div>

      <div
        role="button"
        className="profile-table__menu-item"
        id={`delete-passport-${idx}`}
        onClick={() => {
          return deletePassport(formVals.passports[idx]);
        }}
      >
        <FormattedMessage id="Profile.deleteIdentityDocument" />
      </div>
    </>
  );

  return (
    <div>
      {showForm && (
        <>
          <PassportDocumentsForm
            formVals={formVals}
            index={index}
            setFormVals={setFormVals}
            setErrors={setErrors}
            errors={errors}
            defaultCountry={defaultCountry}
            countries={countries}
          />
          <button
            type="submit"
            validate-button="true"
            id="save-passport"
            className="profile-modal__save"
            onClick={() => {
              if (
                Object.values({
                  ...errors.Issued,
                  ...errors.Citizenship,
                  ...errors.ValidityDate,
                  ...errors.Number,
                }).every((v) => !v)
              ) {
                setShowForm(false);
                setIsNew(false);
              }
            }}
          >
            <FormattedMessage id="Profile.saveChanges" />
          </button>
          {isNew && (
            <button
              type="button"
              className="profile-modal__open-remove-btn"
              onClick={() => {
                setShowForm(false);
                deletePassport(formVals.passports[index]);
                setIsNew(false);
              }}
            >
              <FormattedMessage id="Profile.cancel" />
            </button>
          )}
        </>
      )}

      {isEmpty && !showForm && (
        <div className="profile-main__card">
          <div className="profile-main__card--empty">
            <Img src="/static/images/identity-documents.svg" />
            <div className="profile-main__card-desc">
              <FormattedMessage id="Profile.noIdentityDocuments" />
            </div>
            <div
              role="button"
              className="fake-link"
              id="new-identity-doc-inner-link"
              onClick={() => createNewPassport()}
            >
              <FormattedMessage id="Profile.addNewIdentityDocument" />
            </div>
          </div>
        </div>
      )}

      {!isEmpty && !showForm && (
        <div className="profile-modal__button-section">
          <Table
            rows={passports.map((d) => [
              d.Number,
              countryDetailRow(d.Issued),
              countryDetailRow(d.Citizenship),
              `${intl.formatMessage({
                id: "Profile.exp",
              })} ${moment(d.ValidityDate).format(
                dayMonthYearFormat(defaultCountry)
              )}`,
            ])}
            data={passports}
            menuItems={menuItems}
            className="identity-documents"
          />
          <button
            type="button"
            className="profile-modal__save"
            onClick={() => createNewPassport()}
          >
            <FormattedMessage id="Profile.addNew" />
          </button>
        </div>
      )}
    </div>
  );
}
